// Component names
export const DUMMY_COMPONENT = 'nav-components:dummy';

// Component tags
export const Tags = {
  SIDE_PANEL: 'SIDE_PANEL',
  MODAL: 'MODAL',
  BANNER: 'BANNER'
};
// Loggers
export const PLATFORM_LOGGER = 'NEST_PLATFORM_LOGGER';
export const SCHEDULER_LOGGER = 'NEST_SCHEDULER_LOGGER';

// Others
export const DEFAULT_PLATFORM_NAME = 'unified-navigation-ui';